import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FileUploadArea } from '@src/app/core/enums/FileUploadArea';
import { ToastrService } from 'ngx-toastr';
import { FileUploadService } from '@src/app/core/services/file-upload.service';
import { Injectable } from '@angular/core';
import { FormComponent } from '../form/form/form.component';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ImageService } from '@src/app/core/services/image.service';
import { FileUpload } from '@src/app/models/fileUpload';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';

@Component({
  selector: 'tlp-add-attachment',
  templateUrl: './add-attachment.component.html',
  styleUrls: ['./add-attachment.component.css'],
  providers: [FileUploadService] // Add the service to the component's providers
})
export class AddAttachmentComponent extends FormComponent implements OnInit {
  @Input() imageKey: string = '';
  @Input() targetImageArea: FileUploadArea = FileUploadArea.General;
  @Output() imageUploaded = new EventEmitter<any>();
  @Input() noOfFilesToLimit: number = 1;
  @Input() lookupKey: string = '';
  @Input() showTitle: boolean = true;
  @Input() showDescription: boolean = true;
  
    form: UntypedFormGroup = new FormGroup({});
    images: FileUpload[] = [] as FileUpload[];
  files: File[] = [];
  isSubmitting = false;
  multiple = false;
  animation = true;
  modalRef?: BsModalRef;
  baseUrl: string = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,    
    private readonly imageService: ImageService,
    private readonly modalService: BsModalService,
    private readonly loadingSpinnerService: LoadingSpinnerService
  ) {
    super();
    
    this.generateForm();
    // this.form = this.fb.group({
    //   files: [null, Validators.required],
    //   title: ['', Validators.required],
    //   description: [''],
    //   area: [FileUploadArea.Property]
    // });
  }

  override ngOnInit(): void {
    // Set the default area based on the input
    if (this.targetImageArea) {
      this.form.get('area')?.setValue(this.targetImageArea);
    }
  }

    public generateForm(isEdit: boolean = false): void {
      this.form = this.fb.group({
        files: [[],],// FileUploadValidators.filesLimit(this.noOfFilesToLimit)],
        title: [''],// Validators.required],
        description: [''],//, Validators.required],
        area: [this.targetImageArea, Validators.required],
      });
  
      this.form.get('files')?.valueChanges.subscribe((files: File[]) => {
        if (files && files.length > 0) {
          this.form.get('title')?.setValue(files[0].name);
        }
      });
    }

  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg',
      backdrop: 'static',
      keyboard: false
    });

    // Subscribe to the onHidden event to refresh the page when the modal closes
    this.modalRef.onHidden?.subscribe(() => {
      window.location.reload();
    });
  }

  onFileChange(event: any): void {
    if (event.target.files && event.target.files.length) {
      this.files = Array.from(event.target.files);
    }
  }

  
  onSubmit() {
    if (!this.validateForm()) {
      this.getErrorMessages().map((message) => {
        this.toastr.error(message);
      });
      return;
    }

    const files: File[] = this.form.get('files')?.value;

    if (files.length === 0) {
      this.toastr.error('You must select an image to upload');
      return;
    }
    this.loadingSpinnerService.show();
    // Create our FormUpload objects    
    let fileUpload = new FileUpload();
    fileUpload.area = FileUploadArea.Property;
    fileUpload.lookupKey = this.lookupKey;
    fileUpload.filePath = files[0].name.toString();
    fileUpload.title = this.form.get('title')?.value;
    fileUpload.description = this.form.get('description')?.value;
    fileUpload.Files = files;
    fileUpload.sortorder = this.images.length + 100;

    const formData = this.createFormData(fileUpload); // from form.component.ts
    this.uploadImage(formData, files[0].name.toString()); 
  }

  uploadImage(formData: FormData, filename: string) {
    if (!formData.has('area') || !formData.has('lookupKey')) {
      throw new Error('FileUpload must have area and lookupKey set');
    }
    // let filename = (formData.get('files')? as File).name.toString();

    this.imageService.uploadFormData(formData).subscribe({
      next: (result: boolean) => {
        this.toastr.success(`'${filename}' uploaded successfully!`);        
      this.loadingSpinnerService.hide();
        return true;
      },
      error: (error) => {
        this.toastr.error(`Error uploading '${filename}'`);
        console.error('Error uploading image:', error);
        return false;
      },
      complete: () => {
        this.loadingSpinnerService.hide();
        this.close();
        // // now refresh the images
        // this.refreshImagesFromService();
      },
    });
  }

  close(): void {
    this.modalRef?.hide();
  }
  // a getter for the image url
    public getImageUrl(image: FileUpload) {
      if (image?.filePath)
        return this.baseUrl + '/api/images/' + (image.filePath) 
      else
        return '/assets/images/house-placeholder.jpg';
    }
  
  public validationMessages = {
    title: {
      required: 'Title is required',
    },
    description: {
      required: 'Description is required',
    },
  };
}
